import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactSection.css";

const ContactSection = () => {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_3ongflb", // apna service id
        "template_jwe6ggp", // apna template id
        form.current,
        "75fK7p_GPgVQ98S6o" // apna public key
      )
      .then(
        () => {
          setSent(true);
          setError(false);
          form.current.reset();
        },
        () => {
          setError(true);
          setSent(false);
        }
      );
  };

  return (
    <section className="contact-container" id="contactus-form">
      {/* Left Side Image */}
      <div className="contact-image">
        <img src="/assets/pexels-sheinshine-3127880.jpg" alt="Contact Us" />
      </div>

      {/* Right Side Form */}
      <div className="contact-form-wrapper" data-aos="fade-left">
        <h2 className="contact-title">Get in Touch</h2>
        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <input type="text" name="user_name" placeholder="Your Name" required />
          <input
            type="email"
            name="user_email"
            placeholder="Your Email"
            required
          />
          <textarea
            id="contact1"
            name="message"
            rows="5"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit">Send Message</button>
        </form>

        {sent && (
          <p className="message-status success">
            ✅ Message sent successfully!
          </p>
        )}
        {error && (
          <p className="message-status error">
            ❌ Failed to send message. Please try again.
          </p>
        )}
      </div>
    </section>
  );
};

export default ContactSection;
